import { toWords } from "number-to-words";
import type { AvatarStyle } from "../components/dashboard-primitives";

export function capitalize(word: string): string {
	return word.charAt(0).toUpperCase() + word.slice(1);
}

// Not in the ES2020 lib this app compiles against; present in every browser
// and Node version the app supports, and feature-detected all the same.
type GraphemeSegmenter = new (
	locale?: string,
	options?: { granularity: "grapheme" },
) => { segment(input: string): Iterable<{ segment: string }> };
const Segmenter = (Intl as unknown as { Segmenter?: GraphemeSegmenter })
	.Segmenter;
const graphemeSegmenter = Segmenter
	? new Segmenter(undefined, { granularity: "grapheme" })
	: null;

/**
 * Characters as a reader sees them: a flag or a family emoji is one, not the
 * several code points it is made of. Falls back to code points.
 */
function graphemes(text: string): string[] {
	return graphemeSegmenter
		? Array.from(graphemeSegmenter.segment(text), (part) => part.segment)
		: Array.from(text);
}

export function getInitials(name: string): string {
	if (!name?.trim()) return "?";
	// Taken and trimmed by grapheme, so an emoji initial is never cut in half.
	const letters = name
		.split(" ")
		.map((word) => graphemes(word)[0])
		.join("")
		.toUpperCase();
	return graphemes(letters).slice(0, 2).join("");
}

export function formatCurrency(amount: number): string {
	return `₹${amount.toLocaleString("en-IN")}`;
}

export const AVATAR_STYLES = ["warm", "neutral", "dark", "accent"] as const;

export function getAvatarStyleFromName(name: string): AvatarStyle {
	const hash = name
		.split("")
		.reduce((acc, char) => acc + char.charCodeAt(0), 0);
	return AVATAR_STYLES[hash % AVATAR_STYLES.length];
}

export function formatCountForUI(count: number): string {
	if (count == null || Number.isNaN(count)) return "0";
	if (count >= 1 && count <= 10) return toWords(count);
	return count.toString();
}
